import logo from "assets/gtc-logo.png";

import * as Styled from "./styles";

const Logo = () => <Styled.Logo src={logo} alt="Good time design logo" />;

export default Logo;
